// axios 1.x's browser build runs `new URL()` at module load once it sees the
// window/document stubs below; mini_racer's V8 has no URL global to construct.
import 'core-js/web/url'
// import ReactOnRails from 'react-on-rails'
import noop from 'lodash/noop'

if (typeof window === 'undefined') {
  global.window = { location: {} }
  global.fetch = noop
  window.scrollTo = noop
  window.matchMedia = () => ({
    matches: false,
    addListener: noop,
    removeListener: noop,
  })

  global.clearTimeout = noop
  global.setTimeout = noop

  // Apollo 3.8+'s parser cache uses @wry/caches' WeakCache, which calls
  // queueMicrotask to schedule entry finalization. mini_racer's V8
  // context doesn't expose it, so the first useQuery during SSR throws.
  // Noop is safe — the V8 context is disposed after each SSR, so any
  // cache cleanup that would have run is moot. A Promise-based polyfill
  // floods the microtask queue (one task per useQuery) and balloons
  // SSR time from milliseconds to minutes on cache-heavy pages.
  if (typeof queueMicrotask === 'undefined') {
    global.queueMicrotask = noop
  }
}

if (typeof navigator === 'undefined') {
  global.navigator = {}
}

if (typeof document === 'undefined') {
  global.document = {
    addEventListener: noop,
    querySelector: noop,
  }
}
